/**
 * 呼び出し元画面の出力情報を格納するVO
 *
 * @export KYMW1205OutputModel
 * @class KYMW1205OutputModel
 */
export class KYMW1205OutputModel {
  /** Pコード */
  public pCode: string = '';
}